module.exports = __webpack_public_path__ + "static/img/r2.8235833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/r2.png
// module id = uL+e
// module chunks = 1